import { Pipe, type PipeTransform } from '@angular/core';
import type { Maybe } from '@quipex/core/primitives';
import { toCapitalise } from '@quipex/shared/utils';

@Pipe({
    name: 'qpxCapitalise',
})
export class CapitalisePipe implements PipeTransform {
    /**
     * Transforms a given string by capitalising the first letter of each word
     * and optionally converting the rest of the letters in each word to lowercase.
     *
     * Example usage in a template:
     * ```
     * {{ 'hello WORLD from ANGULAR' | qpxCapitalise }}
     * ```
     * This will render as:
     * ```
     * Hello World From Angular
     * ```
     *
     * To preserve the original case of other characters:
     * ```
     * {{ 'hello WORLD from ANGULAR' | qpxCapitalise:true }}
     * ```
     * This will render as:
     * ```
     * Hello WORLD From ANGULAR
     * ```
     *
     * @param value - The input string to transform.
     * @param preserveCase - If true, only capitalises each word's first
     * character. Defaults to false.
     * @returns The transformed string with each word capitalised correctly.
     */
    transform(value: Maybe<string>, preserveCase = false): string {
        return toCapitalise(value, preserveCase);
    }
}
